import { normalizePeriodBuckets } from './periodizationPeriodBuckets';

export const DEFAULT_ACWR_MAX = 1.3;
export const DEFAULT_ACWR_MIN = 0.8;

/** Canonical display order and defaults for ACWR limit attribute types. */
export const ACWR_LIMIT_TYPE_KEYS = ['acwr_min', 'acwr_max'];

export function defaultForAttributeType(type) {
  if (type?.type_key === 'acwr_max') return DEFAULT_ACWR_MAX;
  if (type?.type_key === 'acwr_min') return DEFAULT_ACWR_MIN;
  return null;
}

export function sortPlanningBlockTypes(types) {
  const order = Object.fromEntries(ACWR_LIMIT_TYPE_KEYS.map((k, i) => [k, i]));
  return [...(types || [])].sort((a, b) => {
    const ao = order[a.type_key] ?? 100 + (a.sort_order || 0);
    const bo = order[b.type_key] ?? 100 + (b.sort_order || 0);
    return ao - bo;
  });
}

export function parseScopeOverrides(raw) {
  if (!raw) return { disabled_types: [], type_buckets: {} };
  const obj = typeof raw === 'string' ? JSON.parse(raw) : raw;
  return {
    disabled_types: Array.isArray(obj.disabled_types) ? obj.disabled_types : [],
    type_buckets: obj.type_buckets && typeof obj.type_buckets === 'object' ? obj.type_buckets : {},
  };
}

export function effectiveBucketsForType(type, blockOverrides) {
  const overrides = parseScopeOverrides(blockOverrides);
  if (overrides.disabled_types.includes(type.type_key)) return null;
  const perType = overrides.type_buckets[type.type_key];
  if (perType) return normalizePeriodBuckets(perType, type.period_buckets);
  return normalizePeriodBuckets(type.period_buckets);
}

export function typesForPlanningScope(attributeTypes, blockOverrides, scope) {
  return (attributeTypes || []).filter((type) => {
    const buckets = effectiveBucketsForType(type, blockOverrides);
    return buckets && buckets[scope];
  });
}

export function resolvePlanningAttribute(typeKey, type, block, phase, micro) {
  const enabled = effectiveBucketsForType(type, block?.planning_scope_overrides);
  if (!enabled) return { value: null, bucket: null };

  const order = [
    ['session', null],
    ['day', null],
    ['week', micro?.attributes],
    ['phase', phase?.attributes],
    ['block', block?.attributes],
  ];

  for (const [bucket, src] of order) {
    if (!enabled[bucket] || !src) continue;
    if (src[typeKey] != null) return { value: src[typeKey], bucket };
  }
  return { value: null, bucket: null };
}

export function resolveAcwrMax(attributeTypes, block, phase, micro) {
  const maxType = (attributeTypes || []).find((t) => t.type_key === 'acwr_max');
  if (!maxType) return DEFAULT_ACWR_MAX;
  const resolved = resolvePlanningAttribute('acwr_max', maxType, block, phase, micro);
  if (resolved.value != null && Number.isFinite(Number(resolved.value))) {
    return Number(resolved.value);
  }
  return DEFAULT_ACWR_MAX;
}
